'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024 from "./presto.types$-Day-Of-Week-Utils$.js";
import * as $j_presto$002etypes$0024$002dRule$002dKind$0024 from "./presto.types$-Rule-Kind$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$$anon$191() {
  this.cfU = null;
  this.cfS = null;
  this.cfT = false;
  this.cfQ = null;
  this.cfR = false;
  this.cfV = false;
  this.cfW = false;
  this.cfU = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_types$proto$$anon$191 as $c_Lpresto_types$proto$$anon$191 };
$p = $c_Lpresto_types$proto$$anon$191.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$$anon$191;
/** @constructor */
function $h_Lpresto_types$proto$$anon$191() {
}
export { $h_Lpresto_types$proto$$anon$191 as $h_Lpresto_types$proto$$anon$191 };
$h_Lpresto_types$proto$$anon$191.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.cfU;
});
$p.t = (function() {
  if ((!this.cfT)) {
    this.cfS = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("kind", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("days", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cfT = true;
  }
  return this.cfS;
});
$p.ag = (function() {
  if ((!this.cfR)) {
    this.cfQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dRule$002dKind$0024.$m_Lpresto_types$RuleKind$().a37(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Encoder$$anon$25($j_presto$002etypes$0024$002dDay$002dOf$002dWeek$002dUtils$0024.$m_Lpresto_types$DayOfWeekUtils$().cIX()), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.cfR = true;
  }
  return this.cfQ;
});
$p.v = (function() {
  if ((!this.cfW)) {
    this.cfV = false;
    this.cfW = true;
  }
  return this.cfV;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_types$proto$$anon$191 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$$anon$191, "presto.types$proto$$anon$191", ({
  a36: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_types$proto$$anon$191 as $d_Lpresto_types$proto$$anon$191 };
//# sourceMappingURL=presto.types$proto$$anon$191.js.map
